import JsPDF from 'jspdf';
import { findIndex, union } from 'lodash';
import generateBarcode from 'pdf417';
import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const mix2DBarcode = ({ shipmentId = '', items = [] }) => {
  const mappedItem = items.map(({ fnsku, quantity, expiryDate }) => ({ fnsku, qty: quantity, exp: (expiryDate?.[0] ? moment(expiryDate[0]).format('YYMMDD') : null) }));
  let stringToEncode = `AMZN,PO:${shipmentId}`;
  mappedItem.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (item[key]) {
        stringToEncode += `,${key.toUpperCase()}:${item[key].toString().toUpperCase()}`;
      }
    });
  });
  return generateBarcode(stringToEncode, 15, 15);
};

const handleFnskuMix2D = ({
  list, doc, x, y, centerX
}) => {
  // eslint-disable-next-line no-param-reassign
  y += 20;
  doc.setFontSize(10);
  let count = list.length;
  let tempY = y;
  if (count > 7) {
    const leftList = list.splice(0, 7);
    leftList.forEach((text) => {
      doc.text(text, x + 1, tempY);
      tempY += 15;
    });
    count = list.length;
    if (count > 7) {
      const rightList = list.splice(0, 6);
      rightList.push(`${count - 6} more items`);
      tempY = y;
      rightList.forEach((text) => {
        doc.text(text, centerX, tempY);
        tempY += 15;
      });
    } else {
      tempY = y;
      list.forEach((text) => {
        doc.text(text, centerX, tempY);
        tempY += 15;
      });
    }
  } else {
    tempY = y
    list.forEach((text) => {
      doc.text(text, x + 1, tempY);
      tempY += 15;
    });
  }
  return doc;
};

const generateMix2DLabelPdf = ({
  shipmentId,
  shipmentName,
  userName,
  doc,
  barcode,
  list,
  totalQuantity
}) => {
  let y = 0;
  const x = 18;
  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();
  const centerX = width / 2;
  doc.setFont('sans-serif');
  y += 25; // top margin
  doc.setFontSize(16);
  doc.setFont(undefined, 'bold');
  doc.text('Box Contents', centerX, y, 'center');
  y += 25;
  doc.setFontSize(13);
  doc.setFont(undefined, 'bold');
  doc.text('Units: ', x, y);
  // doc.text(`User Name: `, centerX, y);
  y += 19;
  doc.setFont(undefined, 'normal');
  doc.text(`${totalQuantity}`, x, y);
  // doc.text(`${userName}`, centerX, y);
  doc.line(3, 84, 285, 84);
  y += 25;
  doc.text('', centerX, y, 'center', null);
  // y += 30;
  doc.addImage(barcode, 'PNG', 22, y, 245, 90, undefined, 'FAST');
  y += 110;
  doc.setFont(undefined, 'bold');
  doc.text('Shipment Name: ', x, y);
  doc.text(`ID: `, centerX, y);
  y += 17;
  doc.setFont(undefined, 'normal');
  doc.text(`${shipmentName.length > 15 ? `${shipmentName.substring(0, 13)}...` : shipmentName}`, x, y);
  doc.text(`${shipmentId}`, centerX, y);
  doc.line(3, y + 10, 285, y + 10);
  y += 20;
  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');
  // eslint-disable-next-line no-param-reassign
  doc = handleFnskuMix2D({
    list, doc, x, y, centerX
  });
  doc.line(3, height - 35, 285, height - 35);
  y = height - 15;
  doc.setFontSize(13);
  doc.setFont(undefined, 'normal');
  doc.text(`Thank you for shipping`, x - 4, y);
  return doc;
};

const box2DLabels = (
  box
) => {
  const width = 432;
  const height = 288;
  let doc = new JsPDF('p', 'pt', [width, height]);
  doc.setLineWidth(1);
  doc.rect(3, 4, height - 6, width - 6);
  let shipment;
  const { shipmentId, shipmentName, userName = '-', items } = box;
  shipment = shipmentId;
  const barcode = mix2DBarcode({ shipmentId, items });
  let totalQuantity = 0;
  const list = [];
  items.forEach(({ units, fulfillmentNetworkSku: fnsku }) => {
    totalQuantity += units;
    const index = findIndex(list, value => value.includes(fnsku));
    if (index !== -1) {
      const listItems = list[index].split(': ');
      const itemQty = Number(listItems.pop());
      list[index] = `${fnsku}: ${units + itemQty}`;
    } else {
      list.push(`${fnsku}: ${units}`);
    }
  });
  // eslint-disable-next-line no-plusplus
  doc = generateMix2DLabelPdf({
    shipmentId,
    shipmentName,
    userName,
    doc,
    barcode,
    totalQuantity,
    list
  });

  doc.save(`${shipment || 'CONTENT_LABEL'}.pdf`);
  return true;
};

export default box2DLabels;